import React from "react"

function Trade(props) {
  const date = new Date(props.data.date);

  let contClasses = "trade2";
  if (props.data.side3) {
    contClasses += " three";
  } else {
    contClasses += " two";
  }

  return <div className={contClasses}>
    <div className="date">{date.toLocaleDateString()}</div>

    <div className="wrap">
      <div className="side">
        <div className="team">{props.teamNames[props.data.side1.team]}</div>
        <div className="action">receives</div>
        <div className="details">
          <ul>
            {props.data.side1.receives.map(function (value, i) {
              return (
                <li key={i}>{value}</li>
              );
            })}
          </ul>
        </div>
      </div>
          
      <div className="side">
        <div className="team">{props.teamNames[props.data.side2.team]}</div>
        <div className="action">receives</div>
        <div className="details">
          <ul>
            {props.data.side2.receives.map(function (value, i) {
              return (
                <li key={i}>{value}</li>
              );
            })}
          </ul>
        </div>
      </div>

      {props.data.side3 ? 
        <div className="side">
          <div className="team">{props.teamNames[props.data.side3.team]}</div>
          <div className="action">receives</div>
          <div className="details">
            <ul>
              {props.data.side3.receives.map(function (value, i) {
                return (
                  <li key={i}>{value}</li>
                );
              })}
            </ul>
          </div>
        </div>
      : ''}
    </div>
  </div>;
}

export default Trade;